import React, { Component } from 'react'
import { TableCol } from 'components/TableCol'
import './DeskRules.scss'
import { RulesRequest } from 'models/request/RulesRequest'
import { getRules } from 'services/CeberusApiService'
import { TenantService } from 'connection/TenantService'

import {
  Card,
  Table,
} from 'antd'
import { BaseRequest } from 'models/request/BaseRequest'

export class DeskRules extends Component<BaseRequest> {
  
  state = {
      isLoading: false,
      rules: [],
      ruleTitle: null,
      ruleTeam: null,
      ruleRelation: null,
      ruleIsActive: null,
      ruleConditions: [],
      ruleProperty: null,
      ruleValues: [],
      ruleOperator: null
  }

  componentDidMount() {
    this.getRules()
  }

  rulesColumns = [
    TableCol({
      title: 'Title',
      dataIndex: 'ruleTitle',
      filter: (value, record) => record.ruleTitle.toString().includes(value.toString())
    }),
    TableCol({
      title: 'Property',
      dataIndex: 'ruleConditions',
      render: ruleConditions => (
        <ul>
          {ruleConditions.map((condition, index) => (
            <li key={index}>{condition.ruleProperty}</li>
          ))}
        </ul>
      )
    }),
    TableCol({
      title: 'Conditions',
      dataIndex: 'ruleConditions',
      render: ruleConditions => (
        <ul>
          {ruleConditions.map((condition, index) => (
            <li key={index}>{condition.ruleRelation}</li>
          ))}
        </ul>
      )
    }),
    TableCol({
      title: 'Values',
      dataIndex: 'ruleConditions',
      filter: (value, record) => {
        const conditions = record.ruleConditions.map(condition => condition.ruleValues);
        return conditions.flat().some(conditionValue => conditionValue.toString().includes(value.toString()));
      },
      render: ruleConditions => (
        <ul>
          {ruleConditions.map((condition, index) => (
            <li key={index}>{condition.ruleValues.join(', ')}</li>
          ))}
        </ul>
      )
    }),
    TableCol({
      title: 'Operator',
      dataIndex: 'ruleOperator'
    }),
    TableCol({
      title: 'Team',
      dataIndex: 'ruleTeam',
      filter: (value, record) => record.ruleTeam.toString().includes(value.toString())
    }),
    TableCol({
      title: 'Is Active',
      dataIndex: 'ruleIsActive'
    }),
  ];

  async getRules() {
    const rulesRequest = new RulesRequest()
    rulesRequest.BotIdentifier = this.props.BotIdentifier
    rulesRequest.ClusterName = TenantService.getSelectedTenant().name
    const { items } = await getRules(rulesRequest)
    let transformedItems = []
    if (items !== undefined) {
      transformedItems = items.map(item => {
        return {
          ...item,
          ruleTitle: item.title,
          ruleIsActive: item.isActive ? 'true' : 'false',
          ruleConditions: item.conditions.map(condition => ({
            ruleProperty: condition.property,
            ruleRelation: condition.relation,
            ruleValues: condition.values
          })),
          ruleOperator: item.operator,
          ruleTeam: item.team,
        }
      })
    }
    this.setState({ rules: transformedItems })
  }
    
  render() {
    return (
      <div>
        <Card>
          <Table 
            dataSource={this.state.rules}
            columns={this.rulesColumns}
          />
        </Card>
      </div>
    )
  }
}